import React, { Component } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

const DotWrapper = styled.button`
  background-color: transparent;
  border: 0;
  cursor: pointer;
  outline: none;
  padding: 0 5px;

  & > span {
    background-color: ${({ color }) => color};
    border-radius: 50%;
    display: inline-block;
    height: 12px;
    opacity: ${({ current }) => (current ? '1.0' : '0.2')};
    transition: opacity 0.2s;
    width: 12px;

    &:hover {
      opacity: 1;
    }
  }
`;

class Dot extends Component {
  handleSlideChange = () => {
    const { onClick, index } = this.props;
    onClick(index);
  };

  render() {
    const { current, color } = this.props;

    return (
      <DotWrapper onClick={this.handleSlideChange} current={current} color={color}>
        <span />
      </DotWrapper>
    );
  }
}

Dot.defaultProps = {
  color: '#000',
};

Dot.propTypes = {
  color: PropTypes.string,
  current: PropTypes.bool.isRequired,
  index: PropTypes.number.isRequired,
  onClick: PropTypes.func.isRequired,
};

export default Dot;



// WEBPACK FOOTER //
// ./src/components/Slider/Dot.js